import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ZusPodatkiService as ZusPodatkiService } from '../../@core/http/zus.service';
import { ZakresDat } from '../../shared/models/zakres-dat.model';
import { ZusPodatki } from '../../shared/models/zus.model';

@Component({
  selector: 'ngx-zus-podatki',
  templateUrl: './zus-podatki.component.html',
  styleUrls: ['./zus-podatki.component.scss'],
})
export class ZusPodatkiComponent implements OnInit, OnDestroy {

  razem: ZusPodatki[];
  wlasciciele: ZusPodatki[];
  pracownicy: ZusPodatki[];
  zusSubscription: Subscription;
  zakresDat: ZakresDat;

  constructor(private readonly zusPodatkiService: ZusPodatkiService) { }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.zusSubscription.unsubscribe();
  }

  onChangeZmianaZakresu(zakresDat: ZakresDat) {
    this.zakresDat = zakresDat;
    this.zusSubscription = this.zusPodatkiService
      .getZusPodatki(zakresDat)
      .subscribe(response => {
        this.razem = response.razem;
        this.wlasciciele = response.wlasciciele;
        this.pracownicy = response.pracownicy;
    });
  }

  onChangeTab($event) {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }
}
